import Button from '@carvana/ds-button';
import { Settings } from 'lucide-react';
import { useContext } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import StaticContext from '~/context/common/StaticContext';
import { BrowserCookies } from '~/utilities';
import { getBranchCookieName } from '~/utilities/featureBranch';

type OwnProps = {
  currentNativeAppCapabilities?: string;
  onOpenPassengerTools: () => void;
};

export default function BranchInfo({
  currentNativeAppCapabilities,
  onOpenPassengerTools
}: OwnProps) {
  const { kubernetesAppName } = useContext(StaticContext);
  const isNative = useIsNative();

  const branchName = BrowserCookies.get(getBranchCookieName(kubernetesAppName));

  return (
    <div className="flex-1">
      <div className="flex-1">
        {branchName ? (
          <>
            <p className="m:inline">Using feature branch </p>
            <p className="font-mono text-xs m:inline">{branchName}</p>
          </>
        ) : null}
      </div>
      <div className="flex-1">
        {currentNativeAppCapabilities ? (
          <>
            <p className="m:inline">Using app capabilities </p>
            <p className="font-mono text-xs m:inline">
              {currentNativeAppCapabilities}
            </p>
          </>
        ) : null}
      </div>
      <div className="flex-1">
        <p className="m:inline">Environment: {isNative ? 'Native' : 'Web'}</p>
      </div>
      <Button
        className="pointer-events-auto mt-md h-28 t-label-xs"
        onClick={onOpenPassengerTools}
        data-analytics-id="Open passenger tools"
        data-testid="open-passenger-tools"
        title="Open passenger tools"
        size="sm"
        utility
      >
        <Settings size={12} /> Passenger
      </Button>
    </div>
  );
}
